import *  as PIXI from "pixi.js";
import Layers from "../../../../src/layers/Layers";
import { Coord } from "../../../../src/types/Interface";
import generatePoints from "../../../../src/utils/generatePoints";
import { CIRCLE_RADIUS } from "../types/Config";


export default class AngleBg extends PIXI.Graphics {
  private Layers = Layers.getInstance();
  startRadian: number;
  endRadian: number;
  private cCoord: Coord;
  private startPoint: Coord;
  private fillColor: number;

  constructor(cCoord: Coord, startPoint: Coord, radian: number, color: number) {
    super();
    this.cCoord = cCoord;
    this.startPoint = startPoint;
    this.startRadian = radian;
    this.endRadian = radian;
    this.fillColor = color;
    this.addToLayer();
  }

  draw(startRadian: number, endRadian: number, startPoint?: Coord) {
    this.startRadian = startRadian;
    this.endRadian = endRadian;
    startPoint ? this.startPoint = startPoint : null;
    this.drawBg()
  };

  private drawBg() {
    const [s1Point, s2Point] = generatePoints(this.cCoord, [this.startRadian, this.endRadian], CIRCLE_RADIUS);
    this
      .clear()
      .moveTo(this.startPoint.x, this.startPoint.y)
      .lineTo(s1Point.x, s1Point.y)
      .arc(this.cCoord.x, this.cCoord.y, CIRCLE_RADIUS, this.startRadian, this.endRadian, true)
      .lineTo(s2Point.x, s2Point.y)
      .fill({ color: this.fillColor, alpha: .7 });
  }
  addToLayer = () => this.Layers.Bottom.addChild(this);
}